import { render, staticRenderFns } from "./AddComplaintModal.vue?vue&type=template&id=46c37a4a&scoped=true"
import script from "./AddComplaintModal.vue?vue&type=script&lang=js"
export * from "./AddComplaintModal.vue?vue&type=script&lang=js"
import style0 from "./AddComplaintModal.vue?vue&type=style&index=0&id=46c37a4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c37a4a",
  null
  
)

export default component.exports